const isShobiddak = () => {
    let isShowbidak = false;
    if (getOriginDomain() === 'shobiddak.com') {
        isShowbidak = true;
    }
    return isShowbidak;
};
const getOriginDomain = () => {
    var hostname = window.location.hostname; // Get the hostname from the current URL
    var parts = hostname.split('.'); // Split the hostname by periods
    if (parts.length > 2) { // Check if there is a subdomain
        hostname = parts.slice(1).join('.'); // Remove the subdomain
    }
    return hostname;
};
export { isShobiddak, getOriginDomain };
